/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { RowDataWrapper, ToolbarRow, TableContainer } from "./styled";
import { Table, Input } from "antd";
import { DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import { useState } from "react";
import { linkApi } from "../../common/ngok";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { showConfirm } from "../../helpers/modal-confirm";

const { Search } = Input;

const RowData = React.memo(() => {
  const { t } = useTranslation();
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  const citiesData = useSelector((state) => state.data.citiesData);

  const [isLoading, setIsLoading] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [numEntries, setNumEntries] = useState({});
  const [search, setSearch] = useState("");
  const [pageSize, setPageSize] = useState(15);

  const getDataRow = async (page, searchVal, size) => {
    if (isLoading) return;
    setIsLoading(true);
    const currentSize = size || pageSize;
    const myHeaders = new Headers({
      Authorization: "Token " + user?.token,
      "Content-Type": "application/x-www-form-urlencoded",
    });
    fetch(
      `${linkApi}/dm/data/raw?page=${page}&size=${currentSize}&search=${searchVal || ""}`,
      { method: "GET", headers: myHeaders }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data?.status === "successful") {
          setRowData(data?.data?.object_list);
          setNumEntries({
            total: data?.data?.num_entries,
            numPages: data?.data?.num_pages,
            page_number: data?.data?.page_number,
          });
        } else {
          showConfirm({
            title: t("common.accountNotAllowed"),
            hideCancel: true,
          });
        }
      })
      .finally(() => setIsLoading(false));
  };

  const handleDelete = async (id) => {
    showConfirm({
      title: t("rawData.confirmDelete"),
      onOk: async () => {
        const myHeaders = new Headers({
          Authorization: "Token " + user?.token,
          "Content-Type": "application/x-www-form-urlencoded",
        });
        try {
          const formData = new URLSearchParams();
          formData.append("record_ids", `[${id}]`);
          const response = await fetch(`${linkApi}/dm/data/raw`, {
            method: "DELETE",
            headers: myHeaders,
            body: formData,
          });
          const data = await response.json();
          if (data?.status === "successful") {
            getDataRow(numEntries.page_number, search);
          }
        } catch (error) {
          console.error("Delete failed:", error);
        }
      },
    });
  };

  useEffect(() => {
    getDataRow(1, "");
  }, []);

  const columns = [
    {
      title: t("rawData.id"),
      dataIndex: "_id",
      key: "_id",
      width: 100,
    },
    {
      title: t("rawData.city"),
      dataIndex: "hosp_province",
      key: "hosp_province",
      width: 150,
      ellipsis: true,
      render: (record) =>
        citiesData?.find((el) => el.code === record)?.name || "",
    },
    {
      title: t("rawData.surveyCriteria"),
      dataIndex: "hosp_criteria_name",
      key: "hosp_criteria_name",
      width: 180,
      ellipsis: true,
    },
    {
      title: t("rawData.hospitalSurveyed"),
      dataIndex: "hosp_hospname",
      key: "hosp_hospname",
      width: 160,
      ellipsis: true,
    },
    {
      title: t("rawData.unitConducting"),
      dataIndex: "hosp_byt_syt",
      key: "hosp_byt_syt",
      width: 140,
      ellipsis: true,
    },
    {
      title: t("rawData.motherName"),
      dataIndex: "minf_moname",
      key: "minf_moname",
      width: 140,
      ellipsis: true,
    },
    {
      title: t("rawData.phoneNumber"),
      dataIndex: "minf_phone",
      key: "minf_phone",
      width: 110,
    },
    {
      title: t("rawData.submissionTime"),
      dataIndex: "_submission_time",
      key: "_submission_time",
      width: 140,
      render: (time) =>
        new Date(time).toLocaleString("vi-VN", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
          timeZone: "Asia/Ho_Chi_Minh",
        }),
    },
    {
      title: t("rawData.action"),
      key: "action",
      width: 90,
      align: "center",
      render: (_, record) => (
        <DeleteOutlined
          style={{ color: "#ff4d4f", cursor: "pointer", fontSize: 16 }}
          onClick={() => handleDelete(record._id)}
        />
      ),
    },
  ];

  return (
    <RowDataWrapper>
      <ToolbarRow>
        <Search
          placeholder={t("rawData.searchPlaceholder") || "Search by KoboID, mother name or phone"}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onSearch={() => getDataRow(1, search)}
          style={{ width: 400 }}
          allowClear
          enterButton={<SearchOutlined />}
        />
        <span style={{ color: "#888", marginLeft: "auto" }}>
          {numEntries?.total ? `${numEntries.total} records` : ""}
        </span>
      </ToolbarRow>

      <TableContainer>
        {!rowData?.length && !isLoading ? (
          <div
            style={{
              textAlign: "center",
              margin: "40px 0",
              fontSize: 16,
              color: "#999",
            }}
          >
            {t("rawData.noRecordFound")}
          </div>
        ) : (
          <Table
            dataSource={rowData}
            columns={columns}
            rowKey="_id"
            size="small"
            loading={isLoading}
            pagination={{
              pageSize: pageSize,
              total: numEntries?.total,
              current: numEntries?.page_number,
              showSizeChanger: true,
              pageSizeOptions: ["10", "15", "30", "50"],
              showTotal: (total) => `${total} records`,
              onChange: (page) => getDataRow(page, search, pageSize),
              onShowSizeChange: (_, size) => {
                setPageSize(size);
                getDataRow(1, search, size);
              },
            }}
          />
        )}
      </TableContainer>
    </RowDataWrapper>
  );
});

export default RowData;
